export const PASSWORD_REGEX = /^[A-Za-z0-9]{0,10}$/;
